import React from "react";
import "./ImportantNotice.css";

const ImportantNotice = () => {
    return (
        <div className="important-notice" role="alert" aria-live="polite">
            <div className="notice-container">
                <div className="notice-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2L13.09 8.26L22 9L13.09 15.74L12 22L10.91 15.74L2 9L10.91 8.26L12 2Z" />
                    </svg>
                </div>
                <div className="notice-content">
                    <span className="notice-text">
                        <strong>🚨 Critical Update:</strong> Our official website has moved to{" "}
                        <a
                            href="https://gobillion.in"
                            className="official-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Visit our new official website gobillion.in"
                        >
                            <strong>gobillion.in</strong>
                        </a>
                        . We are no longer associated with <span className="deprecated-site">gobillion.co</span>. Please update your bookmarks and always verify you're on the correct domain.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ImportantNotice;
